import { render } from "./TheVehicleTrips.vue?vue&type=template&id=6b04e577"
import script from "./TheVehicleTrips.vue?vue&type=script&lang=js"
export * from "./TheVehicleTrips.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__